appHost.actions.register({
    // #region Vars
    name: '288a.commerce.cart.comment',
    // #endregion
    // #region Entry
    async execute(data, params) {
        if (!data) {
            return this.Cancel();
        }
        let tArgs = {
            cartID: data.cartID,
            comment: data.comment
        };
        return this.Window(await appHost.notification.showModal2('g-cart-comment-dialog', tArgs));
    },
    // #endregion
});
export {};
